<div class="error-page-container">
    <div class="logo-container">
        <img class="logo-image" [ngStyle]="('design' | env).logoStyle" [src]="('design' | env).logo">
        <div *ngIf="('design' | env).logoText" class="logo-text ms-2">{{ ('design' | env).logoText }}</div>
    </div>
    <div  *ngIf="!loading" class="error-page-message mt-5 mb-3 px-3 text-center">{{ 'APP.EXTERNALS.AD_LOGIN.MESSAGE' | translate }}</div>
</div>